// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { xmarkCheck16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-xmark-check': IconXmarkCheck;
    }
}

/**
 * The icon component for the 'xmarkCheck' icon
 */
export class IconXmarkCheck extends Icon {
    public constructor() {
        super(xmarkCheck16X16);
    }
}

registerIcon('icon-xmark-check', IconXmarkCheck);
export const iconXmarkCheckTag = 'nimble-icon-xmark-check';
